import api from './api';

const UPLOADS_URL = 'https://murima.julesferry-ga.com/uploads/';

class DashboardService {
  
  async getUserStats(userId) {
    try {
      const response = await api.get(`/get-profile.php?id=${userId}`);
      
      if (response.data.success) {
        const user = response.data.user;
        
        const messagesResponse = await api.get(`/get-conversations.php`);
        let unreadCount = 0;
        if (messagesResponse.data.success) {
          unreadCount = messagesResponse.data.conversations.reduce(
            (sum, conv) => sum + (conv.unread_count || 0), 0
          );
        }
        
        const favoritesResponse = await api.get(`/get-favorites.php?user_id=${userId}`);
        let favoritesCount = 0;
        if (favoritesResponse.data.success) {
          favoritesCount = favoritesResponse.data.favorites?.length || 0;
        }
        
        return {
          success: true,
          data: {
            matches: user.total_likes || 0,
            views: user.total_vues || 0,
            favorites: favoritesCount,
            unreadMessages: unreadCount
          }
        };
      }
      
      return { success: false, data: null };
    } catch (error) {
      console.error('Erreur getUserStats:', error);
      return { success: false, data: null };
    }
  }

async getHotMatches(currentUserId) {
  try {
    const response = await api.get(`/get-hot-matches.php?user_id=${currentUserId}`);
    
    if (response.data.success) {
      const matches = response.data.matches.map(match => ({
        id: match.id,
        pseudo: match.pseudo,
        age: this.calculateAge(match.date_naissance),
        ville: match.ville || 'Paris',
        pays: match.pays || 'France',
        avatar: match.avatar || match.avatar,
        avatar_url: match.avatar_url,
        en_ligne: Boolean(match.en_ligne),
        is_verified: Boolean(match.is_verified),
        is_premium: Boolean(match.is_premium),
        bio: match.bio || 'Aucune bio',
        genre: match.genre || 'autre',
        orientation: match.orientation || 'autre',
        interests: match.interests || [],
        photos: match.photos_count || 0,
        videos: match.videos_count || 0,
        distance: match.distance || Math.floor(Math.random() * 20) + 1,
        derniere_connexion: match.derniere_connexion,
        already_liked: Boolean(match.already_liked), // 🔥 Ajout important
        date_naissance: match.date_naissance // Pour recalculer l'âge si besoin
      }));
      
      console.log('✅ getHotMatches - Profils chargés:', matches.length);
      console.log('✅ already_liked présents:', matches.filter(m => m.already_liked).length);
      
      return { success: true, data: matches };
    }
    
    return { success: false, data: [] };
  } catch (error) {
    console.error('❌ Erreur getHotMatches:', error);
    return { success: false, data: [] };
  }
}

  async getSuggestions(currentUserId) {
    try {
      const response = await api.get(`/get-suggestions.php?user_id=${currentUserId}`);
      
      if (response.data.success) {
        const suggestions = response.data.suggestions.map(s => ({
          ...s,
          avatar: s.avatar ? `${UPLOADS_URL}${s.avatar}` : 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e'
        }));
        return { success: true, data: suggestions };
      }
      
      return { success: false, data: [] };
    } catch (error) {
      console.error('Erreur getSuggestions:', error);
      return { success: false, data: [] };
    }
  }

  async getRecentVisitors(userId) {
    try {
      const response = await api.get(`/get-visitors.php?user_id=${userId}`);
      
      if (response.data.success) {
        const visitors = response.data.visitors.map(visitor => ({
          ...visitor,
          avatar: visitor.avatar ? `${UPLOADS_URL}${visitor.avatar}` : 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e'
        }));
        
        return { success: true, data: visitors };
      }
      
      return { success: false, data: [] };
    } catch (error) {
      console.error('Erreur getRecentVisitors:', error);
      return { success: false, data: [] };
    }
  }

  async getRecentPhotos() {
    try {
      const response = await api.get('/get-recent-photos.php');
      
      if (response.data.success) {
        const photos = response.data.photos.map(photo => ({
          id: photo.id,
          url: photo.url ? `${UPLOADS_URL}${photo.url}` : 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
          user: photo.pseudo,
          likes: photo.likes_count || Math.floor(Math.random() * 50) + 10
        }));
        
        return { success: true, data: photos };
      }
      
      return { success: false, data: [] };
    } catch (error) {
      console.error('Erreur getRecentPhotos:', error);
      return { success: false, data: [] };
    }
  }

  /**
   * Liker un utilisateur
   * @param {number} targetUserId - ID de l'utilisateur à liker
   */
  async likeUser(targetUserId) {
    try {
      // Récupérer l'utilisateur connecté depuis le localStorage
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (!currentUser?.id) {
        return { 
          success: false, 
          error: 'Utilisateur non connecté' 
        };
      }

      // Vérifier que l'utilisateur ne like pas lui-même
      if (parseInt(currentUser.id) === parseInt(targetUserId)) {
        return {
          success: false,
          error: 'Vous ne pouvez pas vous liker vous-même'
        };
      }

      console.log('📤 Like - from:', currentUser.id, 'to:', targetUserId);

      // Envoyer les deux IDs
      const response = await api.post('/like.php', {
        user_id: currentUser.id,
        to_user_id: targetUserId
      });

      console.log('📥 Like response:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur likeUser:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erreur réseau' 
      };
    }
  }

  calculateAge(dateNaissance) {
    if (!dateNaissance) return 0;
    const today = new Date();
    const birthDate = new Date(dateNaissance);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}

export default new DashboardService();